import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { GeckoToastService } from 'ui';

import Condition from './Condition';
import { v4 as uuidv4 } from 'uuid';

class Group extends Component {
  static propTypes = {
    group: PropTypes.shape({
      type: PropTypes.oneOf(['OR', 'AND']),
      conditions: PropTypes.arrayOf(
        PropTypes.shape({
          key: PropTypes.string,
          value: PropTypes.any,
          operator: PropTypes.string,
        })
      ),
    }),
    onChange: PropTypes.func,
    trigger: PropTypes.string,
  };

  changeOperator() {
    const newOp = this.props.group.type === 'OR' ? 'AND' : 'OR';
    const newGroup = Object.assign({}, this.props.group, { type: newOp });
    this.props.onChange(newGroup);
  }

  getOperatorButton() {
    return (
      <div
        className="AddConditions-Group-operator"
        onClick={this.changeOperator.bind(this)}
      >
        {this.props.group.type}
      </div>
    );
  }

  addCondition() {
    const anyInvalid = this.props.group.conditions.find((condition) => {
      return condition.key === null || condition.operator === null;
    });
    if (anyInvalid) {
      let message = '';
      if (anyInvalid.key === null) {
        message =
          'You must add a type to your previous condition before adding a new one.';
      }
      if (anyInvalid.operator === null) {
        message =
          'You must add an operator to your previous condition before adding a new one.';
      }
      if (anyInvalid.key === null && anyInvalid.operator === null) {
        message =
          'You must add an operator and type to your previous condition before adding a new one.';
      }
      return new GeckoToastService().error(message);
    }
    const newConditions = this.props.group.conditions.concat({
      _id: uuidv4(), // Give the condition a unique id so we can track it during rendering later
      key: null,
      value: [],
      operator: null,
      is_group: false,
    });
    const newGroup = Object.assign({}, this.props.group, {
      conditions: newConditions,
    });
    this.props.onChange(newGroup);
  }

  render() {
    return (
      <div className="AddConditions-Group">
        <label>Add Conditions</label>
        {this.props.group.conditions.map((condition, index) => {
          const onChange = (newCondition) => {
            const newConditions = this.props.group.conditions.map((cond) => {
              if (cond._id !== condition._id) {
                return cond;
              }
              return newCondition;
            });
            this.props.onChange(
              Object.assign({}, this.props.group, { conditions: newConditions })
            );
          };
          const removeCondition = () => {
            const newConditions = this.props.group.conditions.filter((cond) => {
              return cond._id !== condition._id;
            });
            this.props.onChange(
              Object.assign({}, this.props.group, { conditions: newConditions })
            );
          };
          return (
            <div key={condition._id}>
              <Condition
                condition={condition}
                trigger={this.props.trigger}
                onChange={onChange}
                removeCondition={removeCondition}
                addCondition={this.addCondition.bind(this)}
              />
              {index !== this.props.group.conditions.length - 1
                ? this.getOperatorButton()
                : null}
            </div>
          );
        })}
      </div>
    );
  }
}

export default Group;
